import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4 pt-5" }
const _hoisted_2 = { class: "text-sm flex items-center" }

import { useCompanyProfile } from '@/account';
import {
	SvgIcon,
	UiButton,
	UiCard,
	UiCardDivider,
	UiForm,
	UiInput,
	UiLoader,
	UiSelect,
	useForm,
	useLoading,
	usePasswordToggling
} from '@/ui-kit';
import { Nullable, phoneNumber } from '@/utils';
import { email, required } from '@vuelidate/validators';
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useTeams } from '../composition/use-teams';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTeamMember',
  setup(__props) {

const toast = useToast();
const router = useRouter();
const route = useRoute();
const {
	addTeamMember,
	editTeamMember,
	selectedMember,
	loadMember,
	roleOptions,
	roles,
	loadRoles
} = useTeams();
const { loading: loadingUser, toggleLoading } =
	useLoading(false);
const { companyId } = useCompanyProfile();

const isEdit = computed(() => !!route.params.memberId);
loadRoles();

const { onSubmit, fillFormData, formData, loading } =
	useForm(
		{
			first_name: '',
			last_name: '',
			email: '',
			password: '',
			role: null as Nullable<number>,
			phone_number: ''
		},
		computed(() => {
			const baseRules = {
				first_name: {
					required
				},
				last_name: {
					required
				},
				role: {
					required
				},
				phone_number: {
					required,
					phoneNumber
				}
			};
			if (!isEdit.value) {
				return {
					email: { required, email },
					password: { required },
					...baseRules
				};
			}
			return baseRules;
		})
	);

const submit = onSubmit(async (formData) => {
	if (!companyId.value) {
		return;
	}

	if (isEdit.value && selectedMember.value) {
		const { password, email, ...restFormData } =
			formData;
		return editTeamMember(
			companyId.value,
			selectedMember.value.id,
			restFormData as any
		).then(() => {
			toast.success(
				'Team member profile was successfully edited!'
			);
			router.push({ name: 'TeamMembers' });
		});
	}

	return addTeamMember(companyId.value, formData).then(
		() => {
			toast.success(
				'Team member was added successfully added!'
			);
			router.push({ name: 'TeamMembers' });
		}
	);
});

onMounted(async () => {
	if (
		!isEdit.value ||
		!selectedMember.value ||
		!companyId.value
	) {
		return;
	}

	const value = {
		...selectedMember.value,
		role: selectedMember.value.role.id
	};
	fillFormData(value);
});

const { passwordIcon, passwordType, togglePasswordType } =
	usePasswordToggling();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, { to: { name: 'TeamMembers' } }, {
      default: _withCtx(() => [
        _createVNode(_unref(UiButton), {
          class: "mb-2",
          theme: "transparent !h-8 !w-auto !min-w-auto !px-2 -mx-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(SvgIcon), {
                name: "arrow",
                class: "h-3 w-3 mr-2 transform rotate-180"
              }),
              _createTextVNode("Back to team members ")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(UiCard), {
      class: "relative",
      theme: "white",
      contentClass: "min-h-300"
    }, {
      default: _withCtx(() => [
        (!_unref(roleOptions).length || _unref(loadingUser))
          ? (_openBlock(), _createBlock(_unref(UiLoader), {
              key: 0,
              loadingText: 
					_unref(loadingUser)
						? 'Loading member details...'
						: 'Loading user roles...'
				,
              wrapperClass: "base"
            }, null, 8, ["loadingText"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_unref(UiCardDivider), {
                title: 
						_unref(isEdit)
							? `Edit profile`
							: 'Add Team Member'
					
              }, null, 8, ["title"]),
              _createVNode(_unref(UiForm), {
                onSubmit: _unref(submit),
                class: "max-w-screen-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UiInput), {
                    label: "First Name",
                    name: "first_name",
                    modelValue: _unref(formData).first_name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).first_name) = $event)),
                    disabled: _unref(loading),
                    placeholder: "Enter first name"
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_unref(UiInput), {
                    label: "Last Name",
                    name: "last_name",
                    modelValue: _unref(formData).last_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).last_name) = $event)),
                    disabled: _unref(loading),
                    placeholder: "Enter last name"
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_unref(UiInput), {
                    label: "Phone number",
                    name: "phone_number",
                    modelValue: _unref(formData).phone_number,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).phone_number) = $event)),
                    disabled: _unref(loading),
                    type: "phone"
                  }, null, 8, ["modelValue", "disabled"]),
                  (!_unref(isEdit))
                    ? (_openBlock(), _createBlock(_unref(UiInput), {
                        key: 0,
                        label: "Email",
                        name: "email",
                        type: "email",
                        modelValue: _unref(formData).email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).email) = $event)),
                        disabled: _unref(loading),
                        placeholder: "Enter email"
                      }, null, 8, ["modelValue", "disabled"]))
                    : _createCommentVNode("", true),
                  (!_unref(isEdit))
                    ? (_openBlock(), _createBlock(_unref(UiInput), {
                        key: 1,
                        label: "Password",
                        name: "password",
                        modelValue: _unref(formData).password,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).password) = $event)),
                        disabled: _unref(loading),
                        type: _unref(passwordType),
                        icon: _unref(passwordIcon),
                        onIconClicked: _unref(togglePasswordType),
                        placeholder: "Type in password"
                      }, null, 8, ["modelValue", "disabled", "type", "icon", "onIconClicked"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(UiSelect), {
                    label: "User Role",
                    name: "role",
                    placeholder: "Select user role",
                    modelValue: _unref(formData).role,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).role) = $event)),
                    options: _unref(roleOptions),
                    disabled: _unref(loading)
                  }, null, 8, ["modelValue", "options", "disabled"]),
                  _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                    default: _withCtx(() => [
                      _createTextVNode("Submit")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})